module.exports = __webpack_public_path__ + "img/sl_staff_hospital.1037c71e.png";